import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Layout from "@/views/layout/index.vue";
import Year100 from "@/views/100/index.vue";
import Leader from "@/views/leader/index.vue";
import Journey from "@/views/journey/index.vue";
import Famous from "@/views/famous/index.vue";
import Old from "@/views/oldgoods/index.vue";
import OldAdd from "@/views/oldgoods/add.vue";
import OldDetail from "@/views/oldgoods/detail.vue";
import Case from "@/views/case/index.vue";
import CaseDetail from "@/views/case/detail.vue";
import H5CaseDetail from "@/views/case/h5-detail.vue";
import Grace from "@/views/grace/index.vue";
import GraceDetail from "@/components/grace/detail.vue";
import GraceAdd from "@/components/grace/add/index.vue";
import Year20 from "@/views/20/index.vue";
import LoginInfo from "@/views/login/index.vue"
// import Agreement from "@/views/login/agreement.vue"
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Layout",
    redirect: "/100",
    component: Layout,
    children: [
      {
        path: "100",
        name: "Year100",
        component: Year100
      },
      {
        path: "leader",
        name: "Leader",
        component: Leader
      },
      {
        path: "journey",
        name: "Journey",
        component: Journey
      },
      {
        path: "famous",
        name: "Famous",
        component: Famous
      },
      {
        path: "old",
        name: "Old",
        component: Old
      },
      {
        path: "old/detail/:id",
        name: "OldDetail",
        component: OldDetail,
        props: true
      },
      {
        path: "case",
        name: "Case",
        component: Case
      },
      {
        path: "case/detail/:id",
        name: "CaseDetail",
        component: CaseDetail,
        props: true
      },
      {
        path: "grace",
        name: "Grace",
        component: Grace
      },
      {
        path: "graceDetail/:id",
        name: "GraceDetail",
        props: true,
        component: GraceDetail
      },
      {
        path: "20",
        name: "Year20",
        component: Year20
      }
    ]
  },
  {
    path: "/old/add",
    name: "OldAdd",
    props: true,
    component: OldAdd
  },
  {
    path: "/grace/add",
    name: "GraceAdd",
    props: true,
    component: GraceAdd
  },
  {
    path: "/login",
    name: "Login",
    component: LoginInfo
  },
  {
    path: "/h5/:id",
    name: "H5",
    component: H5CaseDetail,
    props: true
  },
  {
    path: "/forgetPwd",
    name: "ForgetPwd",
    component: LoginInfo
  }, {
    path: "/register",
    name: "Register",
    component: LoginInfo
  }, {
    path: "/agreement",
    name: "Agreement",
    component: LoginInfo
  }, {
    path: "/person-center",
    name: "PersonCenter",
    component: LoginInfo
  },

];

const router = new VueRouter({
  routes,
  mode: "hash"
});
router.afterEach((to, from) => {
  window.scrollTo(0,0);
})
export default router;
